<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container class="py-10">
        <v-row class="mb-10">
          <v-col cols="6">
            <h1 class="font-weight-bold">Bedrijven</h1>
          </v-col>
          <v-col cols="6" class="ml-auto text-right">
            <v-btn color="secondary" elevation="0" @click="openMenu"
              >Bedrijf toevoegen</v-btn
            >
          </v-col>
        </v-row>
        <v-card elevation="0" class="p-3 h-100">
          <v-data-table
            class="kyano-hover-link"
            :headers="headers"
            :items="companies"
            :items-per-page="25"
            @click:row="handleClick"
          >
          </v-data-table>
        </v-card>
      </v-container>
    </v-main>
    <Drawer :direction="'right'" :exist="true" ref="LeftDrawer">
      <v-container fluid class="pa-5 pa-md-15">
        <h2>Nieuwe bedrijf toevoegen</h2>

        <v-row class="ma-4"></v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field label="Bedrijfsnaam" outlined></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="ml-auto text-right">
            <v-btn color="secondary" right @click="submit" elevation="0">
              Aanmaken
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </Drawer>
  </v-app>
</template>
<script>
import Navigations from "../../components/Navigations.vue";
import Drawer from "../../components/Drawer.vue";
export default {
  components: {
    Navigations,
    Drawer,
  },
  methods: {
    openMenu() {
      if (this.$refs.LeftDrawer.active) {
        this.$refs.LeftDrawer.close();
      } else {
        this.$refs.LeftDrawer.open();
      }
    },
    handleClick(v) {
      this.$router.push(v.to);
    },
    newprofile() {
      // HIER WORD GEPOST NAAR DE BACKEND
      // DAARNA DOOR ROUTEN
    },
  },

  data() {
    return {
      breadcrumb: [
        {
          text: "Bedrijven",
          disabled: true,
          href: "/companies",
        },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Bedrijfsnaam", value: "name" },
        { text: "Aantal cards", value: "cardscount" },
        { text: "Aantal medewerkers", value: "profilescount" },
      ],

      companies: [
        {
          id: 1,
          name: "Snelwebcenter",
          cardscount: 12,
          profilescount: 14,
          to: `/companies/1`,
        },
      ],
    };
  },
};
</script>
